import React from "react";
import {
  Paper,
  Typography,
  List,
  ListSubheader,
  Divider,
  makeStyles,
  createStyles,
} from "@material-ui/core";

import CheckItem from "../common/CheckItem";
import TextItem from "./TextItem";
import SelectItem from "../common/SelectItem";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    list: {
      width: "100%",
    },
    listHeader: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),
    },
    normalPaper: {
      width: "100%",
      maxWidth: "600px",
      marginBottom: theme.spacing(2),
    },
    normalTitle: {
      margin: theme.spacing(2),
    },
  })
);

const InputForm = React.memo((props) => {
  const { inputData, onChange } = props;

  const classes = useStyles();

  const InputComponent = React.memo((props) => {
    const { item, rootIdx, childIdx, grandChildIdx } = props;

    switch (item.type) {
      case "checkbox":
        return (
          <CheckItem
            item={item}
            defaultChecked={item.value}
            onChange={onChange}
            rootIdx={rootIdx}
            childIdx={childIdx}
            grandChildIdx={grandChildIdx}
          />
        );
      case "select":
        return (
          <SelectItem
            item={item}
            defaultValue={item.value}
            onChange={onChange}
            rootIdx={rootIdx}
            childIdx={childIdx}
            grandChildIdx={grandChildIdx}
          />
        );
      default:
        return (
          <TextItem
            item={item}
            defaultValue={item.value}
            onChange={onChange}
            rootIdx={rootIdx}
            childIdx={childIdx}
            grandChildIdx={grandChildIdx}
          />
        );
    }
  });

  return (
    <>
      {inputData.map((item, rootIdx) => (
        <Paper className={classes.normalPaper} key={rootIdx} elevation={2}>
          {/* タイトル表示 */}
          {/* 一項目の場合はタイトル表示しない */}
          {/* TODO:要リファクタリング */}
          {item.child.length === 1 ? null : (
            <Typography className={classes.normalTitle}>{item.name}</Typography>
          )}

          <List className={classes.list}>
            {item.child.map((childItem, childIdx) => (
              <div key={childIdx}>
                {childItem.child === undefined ? (
                  <InputComponent
                    item={childItem}
                    rootIdx={rootIdx}
                    childIdx={childIdx}
                  />
                ) : (
                  <>
                    <Divider />
                    {/* 項目をタイトル表示 */}
                    <ListSubheader
                      className={classes.listHeader}
                      disableSticky={true}
                      color="primary"
                    >
                      {childItem.name}
                    </ListSubheader>

                    {childItem.child.map((grandChildItem, grandChildIdx) => (
                      <div key={grandChildIdx}>
                        <InputComponent
                          item={grandChildItem}
                          rootIdx={rootIdx}
                          childIdx={childIdx}
                          grandChildIdx={grandChildIdx}
                        />
                      </div>
                    ))}
                  </>
                )}
              </div>
            ))}
          </List>
        </Paper>
      ))}
    </>
  );
});

export default InputForm;
